@if(agreementDefinition()) {
<div class="inputPersonalAgreement">
    @if (hideAgreementText()) {
    <button
            type="button"
            class="submit_linkLook"
            [disabled]="disabledIntern()"
            (click)="toggleAgreementText()">
        {{ toggleAgreementTextButtonLabel() }}
    </button>
    }
    @if (renderAgreementText()) {
    <his-safe-html class="agreementText" [html]="agreementDefinition().agreementText" />
    }

    <div class="inputPersonalAgreement-agreement">
        @if (isTypeExplicit()) {
        <his-plam [label]="explicitAgreementConsentLabel()">
            <input
                   type="radio"
                   #content
                   [disabled]="isConsentDisabled()"
                   [checked]="value()?.status === agreementStatus.CONSENTED"
                   (change)="onStatusChange(true)">
        </his-plam>

        <his-plam [label]="explicitAgreementDeclineLabel()">
            <input
                   type="radio"
                   #content
                   [disabled]="isDeclineDisabled()"
                   [checked]="value()?.status === agreementStatus.DECLINED"
                   (change)="onStatusChange(false)">
        </his-plam>
        }

        @else {
        <his-plam [label]="implicitAgreementLabel()">
            <input type="checkbox"
                   #content
                   [checked]="value()?.status === agreementStatus.CONSENTED"
                   [disabled]="isConsentDisabled()"
                   (change)="onStatusChange($event.target.checked)">
        </his-plam>
        }
    </div>
</div>
}